module.exports = __webpack_public_path__ + "img/wp-easy-updates.89707a3c.png";